import styled from '@emotion/styled';
import { Grid, Typography } from '@mui/material';
import { Select } from 'components/molecules/Select';

export const StyledSelect = styled(Select)`
  & .MuiOutlinedInput-root {
    height: 40px;
  }
`;

export const StyledWarningSearch = styled(Grid)`
  margin-bottom: 25px;
`;

export const StyledNotesTypography = styled(Typography)`
  & li {
    margin-left: 20px;
  }
`;
